import React, { FC, useEffect, useState } from "react";
//WARNING import moment from "moment";
import "./NavBarCalendarRoom/NavBarCalendarRoom";
import { es } from "date-fns/locale";
import "./CalendarReservation.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.module.css";
import { useReservationStore, useSlotStore, useAuthStore } from "../../hooks";
import { Car } from "shared/Navigation/InformacionCarrito";
import { useRoomStore } from "../../hooks";
import { X, Info, DoorOpen, Lock, Plus, Check, UserRound, Phone, Mail, Copy } from "lucide-react";
import { utcToZonedTime, format } from 'date-fns-tz';
//import BackgroundSection from "components/BackgroundSection/BackgroundSection";

// Estilos reutilizables (dark glass)
const btnPrimary =
  "inline-flex w-full items-center justify-center gap-1.5 rounded-lg bg-violet-500 px-3 py-2 text-sm font-semibold text-white shadow-lg shadow-violet-500/25 transition hover:bg-violet-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400/50";
const btnGhost =
  "inline-flex w-full items-center justify-center gap-1.5 rounded-lg border border-white/15 bg-white/5 px-3 py-2 text-sm font-medium text-slate-200 transition hover:bg-white/10 focus:outline-none";
const btnSuccess =
  "inline-flex w-full items-center justify-center gap-1.5 rounded-lg bg-emerald-500 px-3 py-2 text-sm font-semibold text-white transition hover:bg-emerald-600 focus:outline-none";
const tileBtnPrimary =
  "inline-flex w-full items-center justify-center gap-1.5 rounded-lg bg-violet-500/90 px-3 py-2 text-sm font-semibold text-white transition hover:bg-violet-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-violet-400/50";
const tileBtnGhost =
  "inline-flex w-full items-center justify-center gap-1.5 rounded-lg border border-white/20 bg-white/10 px-3 py-2 text-sm font-semibold text-white transition hover:bg-white/20 focus:outline-none";
const tileBtnDanger =
  "inline-flex w-full items-center justify-center gap-1.5 rounded-lg bg-rose-500/90 px-3 py-2 text-sm font-semibold text-white transition hover:bg-rose-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-400/50";
// Ajuste compacto para móvil: evita que los botones se desborden del recuadro del slot
const tileBtnCompact =
  "min-w-0 max-w-full gap-1 whitespace-nowrap px-2 py-1.5 text-xs lg:gap-1.5 lg:px-3 lg:py-2 lg:text-sm";
const inputDark =
  "w-full rounded-lg border border-white/10 bg-white/5 px-3 py-2 text-sm font-normal text-white placeholder-slate-500 transition focus:border-violet-500 focus:outline-none focus:ring-2 focus:ring-violet-500/30";
const modalOverlay = "fixed inset-0 z-[100] flex items-center justify-center overflow-y-auto bg-black/70 p-4 backdrop-blur-sm";
const iconCloseBtn = "absolute right-3 top-3 grid h-9 w-9 place-items-center rounded-lg text-slate-400 transition hover:bg-white/10 hover:text-white";
//import { MessageCircleMore } from "lucide-react";
//import { Tooltip } from 'react-tooltip';


<link
  rel="stylesheet"
  href="https://maxst.icons8.com/vue-static/landings/line-awesome/line-awesome/1.3.0/css/line-awesome.min.css"
></link>;



interface Reservation {
  _id: string;
  start: string;
  end: string;
  date: string;
  npersons: number;
  price: string;
  slot: string;
  typereservation: string;
  statuspayment: string;
  usernote: string;
  user: {
    id: string;
    name: string;
    email: string;
    phone: string;
  };
  room: {
    id: string;
    name: string;
    capacidadMin: string;
    capacidadMax: string;
  },
  totalPayed: string;
  __v: number;
}

interface Room {
  capacidad: string;
  capacidadMin: string;
  id: string;
  images: Array<{ url: string }>;
  name: string;
  services: Array<{
    a: string;
    b: string;
    c: string;
    d: string;
    e: string;
  }>;
}


interface Slot {
  id: string;
  room: string;
  start: string;
  end: string;
  price: string;
  dayOfWeek: string;

}
interface PropsRoomCalendar {

  rooms?: Room[];
}



const CalendarReservation: FC<PropsRoomCalendar> = () => {
  const [isOpen, setIsOpen] = useState(false); //state para modal de informacion de la reserva
  const [isOpenAdmin, setIsOpenAdmin] = useState(false); //state para hacer una reserva desde el administrador
  const [modalOpenRoom, setModalOpenRoom] = useState(false)
  const [codeReservation, setCodeReservation] = useState("")

  //Datos formulario crear reserva Admin
  const [formValues, setFormValues] = useState({
    startR: "",
    endR: "",
    dateR: "",
    salaName: "",
    salaIdR: "",
    npersonsR: "",
    userNameR: '',
    userPhoneR: '',
    userEmailR: '',
    slotR: "",
    priceR: "",
    typereservationR: "",
    statusPaymentR: "",
  });
  //Tipo de reserva
  //1: Reservado
  //2: Bloqueado o cerrado por el admin

  //Aqui trae el json que contiene los slot de las salas
  const {
    reservations,
    getReservations,
    closeRoom,
    openRoom,
    car,
    getReservationById,
    createReservationAdmin
  } = useReservationStore();

  const [reservaData, setReservaData] = useState<Reservation>({
    _id: "",
    start: "",
    end: "",
    date: "",
    npersons: 0,
    user: {
      id: "",
      name: "",
      email: "",
      phone: "",
    },
    room: {
      id: "",
      name: "",
      capacidadMin: "",
      capacidadMax: "",
    },
    totalPayed: "",
    slot: "",
    price: "",
    typereservation: "",
    statuspayment: "",
    usernote: "",
    __v: 0,
  });


  //Estados para poder mostrar la hora de inicio y fin cuando el admin quiera hacer una reserva
  const [horaInicioSlot, setInicioSlot] = useState("");
  const [horaFinalSlot, setFinalSlot] = useState("");
  const [capacidadSalaState, setCapacidadSala] = useState("");
  const [salaNameState, setSalaName] = useState("");
  const [phoneCopied, setPhoneCopied] = useState(false); // feedback "copiado" del teléfono
  const { rooms, getRooms } = useRoomStore();

  // WhatsApp exige el número SOLO con dígitos y código de país: sin "+", espacios
  // ni guiones. Si se le pasa el número con esos caracteres, WhatsApp lo interpreta como
  // inválido y muestra una pantalla en negro/"número no válido" (comportamiento que variaba
  // según el navegador). Dejamos solo dígitos.
  const whatsappDigits = (phone: string) => String(phone || "").replace(/\D/g, "");
  const WHATSAPP_TEXT = encodeURIComponent("¡Estoy interesado!");

  // Enlace web (wa.me): se usa como href visible/copiable y como fallback si no hay app.
  const buildWhatsappLink = (phone: string) =>
    `https://wa.me/${whatsappDigits(phone)}?text=${WHATSAPP_TEXT}`;

  // Al hacer click en el teléfono intentamos abrir la aplicación de WhatsApp instalada
  // (escritorio o móvil) mediante el esquema whatsapp://. Si en ~1,5s la pestaña no ha perdido
  // el foco (no hay app o el navegador ignoró el esquema), abrimos wa.me en una pestaña nueva.
  const openWhatsappWeb = (phone: string) => {
    window.open(buildWhatsappLink(phone), "_blank", "noopener,noreferrer");
  };

  const openWhatsapp = (e: React.MouseEvent<HTMLAnchorElement>, phone: string) => {
    e.preventDefault();
    const digits = whatsappDigits(phone);
    if (!digits) return;
    const appUrl = `whatsapp://send?phone=${digits}&text=${WHATSAPP_TEXT}`;

    let handled = false;
    const markHandled = () => {
      handled = true;
      cleanup();
    };
    const onVisibility = () => {
      if (document.visibilityState === "hidden") markHandled();
    };
    const cleanup = () => {
      window.removeEventListener("blur", markHandled);
      document.removeEventListener("visibilitychange", onVisibility);
    };
    window.addEventListener("blur", markHandled);
    document.addEventListener("visibilitychange", onVisibility);

    window.setTimeout(() => {
      cleanup();
      if (!handled) openWhatsappWeb(phone);
    }, 1500);

    window.location.href = appUrl;
  };

  // Copia el número tal cual (completo, con su prefijo) al portapapeles y muestra feedback.
  const copyPhone = async (phone: string) => {
    const value = String(phone || "").trim();
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
      } else {
        // Fallback para navegadores/contextos sin Clipboard API (http, Safari antiguo).
        const ta = document.createElement("textarea");
        ta.value = value;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setPhoneCopied(true);
      setTimeout(() => setPhoneCopied(false), 1500);
    } catch (e) {
      console.log("No se pudo copiar el teléfono", e);
    }
  };


  const onInputChanged = ({ target }: any) => {
    setFormValues({
      ...formValues,
      [target.name]: target.value,
    });
  };


  //Modal de reserva para el admin:
  //capacidadSala:string,salaName:string ,capacidadMin:string
  const openModalAdmin = (slot: Slot, codeSlot: string, sala: Room, fechaReservation: Date) => {

    formValues.startR = slot.start;
    formValues.salaName = sala.name;
    formValues.salaIdR = sala.id;
    formValues.endR = slot.end;
    formValues.dateR = fechaReservation.toString();
    formValues.npersonsR = sala.capacidad;
    formValues.slotR = codeSlot;
    formValues.priceR = (parseFloat(slot.price) * parseFloat(sala.capacidadMin)).toFixed(2);


    formValues.typereservationR = "booked";

    setIsOpenAdmin(true);
    setInicioSlot(slot.start);
    setFinalSlot(slot.end);
    setCapacidadSala(sala.capacidad);
    setSalaName(sala.name);
  }


  const closeModalAdmin = () => {
    setIsOpenAdmin(false)
  }

  //Abrir modal de abrir sala
  const handleModalOpenRoom = (fechaCodeSlot: String, slot: Slot) => {
    setCodeReservation(fechaCodeSlot + slot.id)
    setModalOpenRoom(true)
  }

  const handleCloseModalOpenRoom = () => {
    setModalOpenRoom(false)
  }



  // Manejar clic fuera del modal para cerrarlo
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (isOpenAdmin && !event.target.closest(".modal-content-admin")) {
        closeModalAdmin();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpenAdmin]);
  // Manejar tecla Escape para cerrar el modal
  useEffect(() => {
    const handleEscKey = (event: any) => {
      if (isOpenAdmin && event.keyCode === 27) {
        closeModalAdmin();
      }
    };

    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [isOpenAdmin]);


  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const { userNameR, userEmailR, userPhoneR } = formValues;
    // eslint-disable-next-line   
    const data = await createReservationAdmin(
      formValues.priceR,
      formValues.startR,
      formValues.endR,
      formValues.slotR,
      formValues.salaIdR,
      userNameR,
      userEmailR,
      userPhoneR,
      formValues.dateR,
      formValues.typereservationR,
      formValues.statusPaymentR
    ).then(() => {
      getReservations({ date: fechaSeleccionada });
      closeModalAdmin();
    });

  }


  //Modal Informacion de la reserva:
  const abrirModal = async (slot: Slot) => {
    const dato = reservations.find(
      (reservation: any) => reservation.slot === `${fechaCodeSlot}${slot.id}`
    );
    try {

      const reservationData = await getReservationById(dato.id);

      setReservaData({
        ...reservationData.reservation
      })
      console.log("hola123", reservationData.reservation)
    } catch (error) {
      console.error("Error al obtener la reserva:", error);
    }

    setIsOpen(true);


  };

  //Modal Informacion de la reserva:
  /*WARNING
  const openRoomModal = async (slot: Slot) => {
    const dato = reservations.find(
      (reservation: any) => reservation.slot === `${fechaCodeSlot}${slot.id}`
    );
    try {

      const reservationData = await getReservationById(dato.id);

      setReservaData({
        ...reservationData.reservation
      })



    } catch (error) {
      console.error("Error al obtener la reserva:", error);
    }

    setIsOpen(true);


  };*/


  const cerrarModal = () => {
    setIsOpen(false);
  };



  // Manejar clic fuera del modal para cerrarlo
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (isOpen && !event.target.closest(".modal-content")) {
        cerrarModal();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);
  // Manejar tecla Escape para cerrar el modal
  useEffect(() => {
    const handleEscKey = (event: any) => {
      if (isOpen && event.keyCode === 27) {
        cerrarModal();
      }
    };

    document.addEventListener("keydown", handleEscKey);

    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [isOpen]);



  const timeZone = 'Europe/Madrid';
  const fecha = utcToZonedTime(new Date(), timeZone);

  const dia = format(fecha, 'd');
  const mes = format(fecha, 'M');
  const año = format(fecha, 'yy');
  // Convertir día y mes a números
  const diaNumero = Number(dia);
  const mesNumero = Number(mes);

  const diaFormateado = diaNumero < 10 ? "0" + dia : dia;
  const mesFormateado = mesNumero < 10 ? "0" + mes : mes;

  const [fechaSeleccionada, setFechaSeleccionada] = useState<Date>(fecha);
  const [fechaCodeSlot, setFechaCodeSlot] = useState<string>(
    `${diaFormateado}${mesFormateado}${año}`
  );









  const { getSlots, slots, slotsDayOfWeek } = useSlotStore();
  // Solo se pintan los slots del día seleccionado (descarta respuestas tardías de otro día;
  // evita cerrar o reservar la plantilla de otro día de la semana).
  const slotsDelDia: Slot[] =
    String(slotsDayOfWeek) === String(fechaSeleccionada.getDay()) ? slots : [];
  const { user } = useAuthStore();
  //const [fechaActual, setFechaActual] = useState<Date>(utcToZonedTime(new Date(), timeZone));




  //aqui se actualiza dependiendo si el slot se borra en el carrito, vuelve a su estado normal
  const isSlotReserved = (slotId: string) => {
    return car.some((item: Car) => item.id === slotId);
  };

  const handleFechaChange = (date: Date) => {
    setFechaSeleccionada(date);

    /*DOM:0,LUN:1,M:2*/
  };

  const handlePrevDay = () => {
    //const prevDay = new Date(fechaActual.getTime() - 24 * 60 * 60 * 1000);
    //setFechaActual(prevDay);
    const prevDay = new Date(fechaSeleccionada.getTime() - 24 * 60 * 60 * 1000);

    setFechaSeleccionada(prevDay);
    // Lógica para actualizar los datos de acuerdo a la fecha seleccionada
  };

  const handleNextDay = () => {
    //const nextDay = new Date(fechaActual.getTime() + 24 * 60 * 60 * 1000);
    //setFechaActual(nextDay);

    const nextDay = new Date(fechaSeleccionada.getTime() + 24 * 60 * 60 * 1000);
    setFechaSeleccionada(nextDay);
    // Lógica para actualizar los datos de acuerdo a la fecha seleccionada
  };


  useEffect(() => {
    getSlots({ dayOfWeek: fechaSeleccionada.getDay() });
    getReservations({ date: fechaSeleccionada });
    getRooms();

    //Es para que cada slot tenga un id unico
    const dia = fechaSeleccionada.getDate();
    const mes = fechaSeleccionada.getMonth() + 1;
    const año = fechaSeleccionada.getFullYear() % 100;

    const diaFormateado = dia < 10 ? "0" + dia : dia;
    const mesFormateado = mes < 10 ? "0" + mes : mes;
    setFechaCodeSlot(`${diaFormateado}${mesFormateado}${año}`);
    //--------
  }, [fechaSeleccionada]);


  return (
    <div className="sticky">
      <div className="filtros">
        <i className="las la-sliders-h"></i>
        <a href="/#">Filtros</a>
      </div>

      <div className="inputDateReservation mb-10 mt-10  ">
        <button onClick={handlePrevDay}>{"<"}</button>
        <DatePicker
          id="fechaSelector"
          selected={fechaSeleccionada}
          onChange={handleFechaChange}
          dateFormat="EEEE dd 'de' MMM"
          locale={es}
        />

        <i className="las la-calendar-minus"></i>
        <button onClick={handleNextDay}>{">"}</button>
      </div>

      {/* <div className="NavCalendarRoom">
        <NavBarCalendarRoom />
      </div> */}

      <div className="sala-horario-container">
        {rooms.map((room: Room) => (
          <div key={room.id} className="sala-item">
            <div className="horarios-disponibles">
              <div className="salaImage">
                <h3>{room.name}</h3>

                {/* <p className="sala-capacidad">{sala.capacidad}</p> */}
                {/*<p className="sala-ubicacion">{sala.ubicacion}</p>*/}
                <img src={room.images[0].url} alt={room.name} />

                {/* <img src={salaImages[sala.id]} alt={`Sala ${sala.name}`} /> */}
                <div className="absolute top-3 left-5 rounded-2xl bg-purple-600 text-sm text-white p-1">
                  <i className="las la-user text-[16px]"></i> Min{" "}
                  {room.capacidadMin} / Max {room.capacidad}
                </div>
              </div>
              <div className="contenedor-horario-slot">
                {slotsDelDia
                  .filter((slot: Slot) => slot.room === room.id)
                  .map((slot: Slot, index: number) => {
                    // Verificar si el slot actual está en las reservaciones
                    const reservation = Array.isArray(reservations) ? reservations.find(
                      (reservation: any) =>
                        reservation.slot === `${fechaCodeSlot}${slot.id}`
                    ) : []

                    const isReserved = !!reservation;
                    const isClosed =
                      isReserved && reservation.typereservation === "closed";

                    return (
                      <div
                        key={index}
                        className={`horario-slot2 ${isReserved ? (isClosed ? "cerrado" : "reservad") : ""
                          } ${isSlotReserved(`${fechaCodeSlot}${slot.id}`)
                            ? "sala-reservada1"
                            : ""
                          }`}
                      >
                        {!isReserved ? (
                          <div className="">
                            {isSlotReserved(`${fechaCodeSlot}${slot.id}`) ? (
                              <div>
                                <p className="mt-5 sm:mt-5 md:mt-5 lg:mt-10 xl:mt-10">
                                  Sala Reservada
                                </p>
                                <button
                                  onClick={() => abrirModal(slot)}
                                  className={`${tileBtnPrimary} mt-2`}
                                >
                                  <Info size={14} /> Info. Reserva
                                </button>
                                {/* Modal */}

                              </div>
                            ) : (
                              <div className="w-full flex flex-col text-[1em] lg:text-base xl:text-xl">
                                {slot.start} - {slot.end}
                                <br />
                                <p className="precio2 text-[1em] lg:text-base xl:text-xl">{slot.price}€ /Pers.</p>
                              </div>
                            )}

                            <div>
                              <div className="w-full flex flex-col items-center gap-1.5">
                                {!isSlotReserved(
                                  `${fechaCodeSlot}${slot.id}`
                                ) && (
                                    <>
                                      <button
                                        onClick={(e) => {
                                          closeRoom(
                                            room.id,
                                            0,
                                            slot.start,
                                            slot.end,
                                            `${fechaCodeSlot}${slot.id}`,
                                            room.capacidad,
                                            user.uid,
                                            fechaSeleccionada,
                                            "closed"
                                          );
                                        }}
                                        className={`${tileBtnGhost} ${tileBtnCompact} lg:w-[65%]`}
                                      >
                                        <Lock size={14} /> Cerrar
                                      </button>
                                      {/*<input type="text" id={`${fechaCodeSlot}${slot.id}`} />*/}
                                      <button


                                        onClick={() => openModalAdmin(
                                          slot,
                                          `${fechaCodeSlot}${slot.id}`,
                                          room,

                                          fechaSeleccionada
                                        )}
                                        className={`${tileBtnPrimary} ${tileBtnCompact} lg:w-[65%]`}
                                      >
                                        <Plus size={14} /> Reservar
                                      </button>

                                    </>
                                  )}
                              </div>

                            </div>
                          </div>
                        ) : (
                          <div className=" text-white mt-2 grid justify-items-center items-center">
                            <span className="text-[1em] lg:text-base xl:text-xl">{isClosed ? "Sala cerrada" : "Sala reservada"}</span>

                            <span className="text-[1em] lg:text-base xl:text-xl">
                              {slot.start} - {slot.end}
                            </span>
                            {modalOpenRoom && (

                              <div className={modalOverlay}>
                                <div className="modal-content w-full max-w-sm rounded-2xl border border-white/10 bg-[#15101f]/95 p-6 text-white shadow-2xl backdrop-blur-xl">
                                  <div className="flex flex-col items-center text-center">
                                    <span className="mb-4 grid h-14 w-14 place-items-center rounded-full bg-amber-500/15 text-amber-300">
                                      <DoorOpen size={26} />
                                    </span>
                                    <h2 className="text-xl font-bold">¿Desea abrir la sala?</h2>
                                    <p className="mt-2 text-sm text-slate-400">Si abre la sala se borrará la reserva realizada.</p>
                                    <div className="mt-6 flex w-full gap-3">
                                      <button onClick={() => handleCloseModalOpenRoom()} className={btnGhost}>
                                        Cancelar
                                      </button>
                                      <button
                                        onClick={() => {
                                          openRoom(codeReservation, fechaSeleccionada);
                                          handleCloseModalOpenRoom();
                                        }}
                                        className={btnSuccess}
                                      >
                                        <Check size={16} /> Aceptar
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            )}


                            {isClosed ? (
                              //Reserva cerrada
                              <>

                                {/*onClick={() => openRoom(`${fechaCodeSlot}${slot.id}`, fechaSeleccionada)}*/}
                                <button
                                  onClick={() => handleModalOpenRoom(fechaCodeSlot, slot)}
                                  className={`${tileBtnDanger} lg:w-[85%]`}
                                  type="button"
                                >
                                  <DoorOpen size={14} /> Abrir sala
                                </button>



                              </>


                            ) : (


                              // Reserva no cerrada
                              <div className="w-full justify-center items-center flex flex-row lg:flex-col ">

                                {
                                /*<div data-tooltip-id="my-tooltip" data-tooltip-content={reservaData.usernote}>
                                  <MessageCircleMore className="text-white absolute top-0 left-0 hover:text-gray-900 cursor-pointer" />
                                </div>
                                <Tooltip id="my-tooltip" />
                                */}

                                <button
                                  onClick={() => abrirModal(slot)}
                                  className={`${tileBtnPrimary} lg:w-[85%] my-0.5`}
                                  type="button"
                                >
                                  <Info size={14} /> Info. Sala
                                </button>
                                <button
                                  onClick={() => handleModalOpenRoom(fechaCodeSlot, slot)}
                                  className={`${tileBtnDanger} lg:w-[85%] my-0.5`}
                                  type="button"
                                >
                                  <DoorOpen size={14} /> Abrir sala
                                </button>

                                <div>



                                  {/* Modal de informacion de la reserva */}
                                  {isOpen && (
                                    <div className={modalOverlay}>
                                      <div className="modal-content relative w-full max-w-lg rounded-2xl border border-white/10 bg-[#15101f]/95 p-6 text-white shadow-2xl backdrop-blur-xl sm:p-8">
                                        <button onClick={() => cerrarModal()} aria-label="Cerrar" className={iconCloseBtn}>
                                          <X size={20} />
                                        </button>

                                        <div className="mb-4 flex items-center gap-2">
                                          <span className="grid h-10 w-10 place-items-center rounded-xl bg-violet-500/15 text-violet-300"><Info size={20} /></span>
                                          <h2 className="text-lg font-bold">Datos de la reserva</h2>
                                        </div>
                                        <div className="space-y-2 text-sm">
                                          <div className="flex justify-between gap-4"><span className="text-slate-400">Sala</span><span className="font-semibold text-white">{reservaData.room.name}</span></div>
                                          <div className="flex justify-between gap-4"><span className="text-slate-400">Inicio</span><span className="font-semibold text-white">{reservaData.start}</span></div>
                                          <div className="flex justify-between gap-4"><span className="text-slate-400">Final</span><span className="font-semibold text-white">{reservaData.end}</span></div>
                                          <div className="flex justify-between gap-4"><span className="text-slate-400">Reserva para</span><span className="font-semibold text-white">{reservaData.room.capacidadMin} personas</span></div>
                                          <div className="flex items-center justify-between gap-4">
                                            <span className="text-slate-400">Estado de pago</span>
                                            <span className={`rounded-full px-2.5 py-0.5 text-xs font-semibold ${reservaData.statuspayment.toLowerCase() === "paid" ? "bg-emerald-500/15 text-emerald-300" : "bg-amber-500/15 text-amber-300"}`}>
                                              {reservaData.statuspayment.toLowerCase() === "paid" ? "Pagado" : "Pendiente de pago"}
                                            </span>
                                          </div>
                                        </div>

                                        <hr className="my-5 border-white/10" />

                                        <div className="mb-4 flex items-center gap-2">
                                          <span className="grid h-10 w-10 place-items-center rounded-xl bg-indigo-500/15 text-indigo-300"><UserRound size={20} /></span>
                                          <h3 className="text-lg font-bold">Datos del cliente</h3>
                                        </div>
                                        <div className="space-y-2 text-sm">
                                          <div className="flex justify-between gap-4"><span className="text-slate-400">Nombre</span><span className="font-semibold text-white">{reservaData.user.name}</span></div>
                                          <div className="flex justify-between gap-4"><span className="flex items-center gap-1.5 text-slate-400"><Mail size={14} /> Email</span><span className="font-semibold text-white">{reservaData.user.email}</span></div>
                                          <div className="flex justify-between gap-4"><span className="flex items-center gap-1.5 text-slate-400"><Phone size={14} /> WhatsApp</span><span className="flex items-center gap-2"><a rel="noreferrer" className="font-semibold text-emerald-300 hover:text-emerald-200" href={buildWhatsappLink(reservaData.user.phone)} onClick={(e) => openWhatsapp(e, reservaData.user.phone)} target="_blank" title="Abrir en la aplicación de WhatsApp">{reservaData.user.phone}</a><button type="button" onClick={() => copyPhone(reservaData.user.phone)} title="Copiar teléfono" aria-label="Copiar teléfono" className="grid h-7 w-7 place-items-center rounded-lg bg-white/10 text-slate-300 transition hover:bg-white/20 hover:text-white">{phoneCopied ? <Check size={14} className="text-emerald-300" /> : <Copy size={14} />}</button></span></div>
                                          <div className="flex justify-between gap-4"><span className="text-slate-400">Nota</span><span className="font-semibold text-white">{reservaData.usernote || "—"}</span></div>
                                        </div>

                                        <button onClick={() => cerrarModal()} className={`${btnGhost} mt-6`}>Cerrar</button>
                                      </div>
                                    </div>
                                  )}

                                  {/*Modal para que el admin pueda hacer una reserva */}



                                </div>


                              </div>

                            )}


                          </div>
                        )}
                      </div>
                    );
                  })}
              </div>
            </div>
            {isOpenAdmin && (
              <div className={modalOverlay}>
                <div className="modal-content-admin relative my-8 w-full max-w-md rounded-2xl border border-white/10 bg-[#15101f]/95 p-6 text-white shadow-2xl backdrop-blur-xl">
                  <button onClick={() => closeModalAdmin()} aria-label="Cerrar" className={iconCloseBtn}>
                    <X size={20} />
                  </button>

                  <div className="mb-4 flex items-center gap-2">
                    <span className="grid h-10 w-10 place-items-center rounded-xl bg-violet-500/15 text-violet-300"><Plus size={20} /></span>
                    <h2 className="text-lg font-bold">Crear reserva</h2>
                  </div>

                  <div className="mb-5 grid grid-cols-2 gap-3 rounded-xl border border-white/10 bg-white/5 p-3 text-sm">
                    <div><p className="text-slate-400">Inicio</p><p className="font-semibold">{horaInicioSlot}</p></div>
                    <div><p className="text-slate-400">Final</p><p className="font-semibold">{horaFinalSlot}</p></div>
                    <div><p className="text-slate-400">Sala</p><p className="font-semibold">{salaNameState}</p></div>
                    <div><p className="text-slate-400">Capacidad</p><p className="font-semibold">{capacidadSalaState}</p></div>
                  </div>

                  <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                      <label htmlFor="userNameR" className="mb-1 block text-sm font-medium text-slate-300">Nombre</label>
                      <input type="text" id="userNameR" name="userNameR" value={formValues.userNameR} onChange={onInputChanged} className={inputDark} />
                    </div>
                    <div>
                      <label htmlFor="userPhoneR" className="mb-1 block text-sm font-medium text-slate-300">Teléfono</label>
                      <input type="tel" id="userPhoneR" name="userPhoneR" value={formValues.userPhoneR} onChange={onInputChanged} className={inputDark} />
                    </div>
                    <div>
                      <label htmlFor="userEmailR" className="mb-1 block text-sm font-medium text-slate-300">Email</label>
                      <input type="email" id="userEmailR" name="userEmailR" value={formValues.userEmailR} onChange={onInputChanged} className={inputDark} required />
                    </div>
                    <div>
                      <label htmlFor="statusPaymentR" className="mb-1 block text-sm font-medium text-slate-300">Estado de pago</label>
                      <select id="statusPaymentR" name="statusPaymentR" value={formValues.statusPaymentR} onChange={onInputChanged} className={inputDark}>
                        <option value="">Estado de pago</option>
                        <option value="pending">Pendiente de pago</option>
                        <option value="paid">Pagado</option>
                      </select>
                    </div>
                    <div className="flex gap-3 pt-1">
                      <button type="button" onClick={() => closeModalAdmin()} className={btnGhost}>Cancelar</button>
                      <button type="submit" className={btnPrimary}><Check size={16} /> Guardar</button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>

        ))}
      </div>

    </div>
  );
};

export default CalendarReservation;
